import React, { useCallback, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';

import { GameMode, GameRedirectionSource } from '../../../../../enums';
import { useStore, useTranslation } from '../../../../../hooks';
import { integration } from '../../../../../services';
import { env } from '../../../../../environment';
import { T } from '../../../../../constants';

interface SidebarPreLobbyProps {
  onClose: () => void;
}

export const SidebarPreLobby: React.FC<SidebarPreLobbyProps> = observer(({ onClose }) => {
  const { lobbyStore, authStore, gameStore } = useStore();
  const t = useTranslation();

  const { preLobbyGamesResponse } = lobbyStore;
  const { data: games } = preLobbyGamesResponse;
  const { hasGameRedirection } = gameStore;
  const { isAuth } = authStore;
  const [searchValue, setSearchValue] = useState('');

  const filteredGames = useMemo(() => {
    return games.filter(game =>
      game.gameName?.toLowerCase().includes(searchValue.toLowerCase())
    );
  }, [games, searchValue]);

  const changeGame = useCallback((gameId: number, mode: GameMode) => {
    integration.current.changeGame({ gameId, mode, source: GameRedirectionSource.PreLobby });
    onClose();
  }, [onClose]);

  return (
    <div className="suggested-block">
      <div className="suggested-block-header">
        <div className="search-block-games">
          <i className="icon-search" />
          <input
            type="text"
            className="search-inp-games"
            placeholder={t(T.SEARCH)}
            value={searchValue}
            onChange={e => setSearchValue(e.target.value)}
          />
        </div>
      </div>
      <div className="suggested-block-content">
        <div className="suggested-block-content-scroll">
          <div className="suggested-block-content-inner">
            {filteredGames.length === 0 && <div>{t(T.NO_DATA_TO_DISPLAY)}</div>}
            {
              filteredGames.map((game) => (
                <div key={game.gameId} className="suggested-block-content-items">
                  <img
                    src={`${env.filesUrl}/${game.thumbnail}`}
                    alt={game.gameName}
                    className="suggested-bg"
                  />
                  <div className="play-now-demo-block">
                    {/* real mode launches the game for the player, so it needs partner-side game redirection */}
                    {isAuth && hasGameRedirection && (
                      <button
                        className="play-now-btn"
                        type="button"
                        onClick={() => changeGame(game.gameId, GameMode.Real)}
                      >
                        {t(T.PLAY_NOW)}
                      </button>
                    )}
                    {game.hasDemo && (
                      <button
                        className="demo-btn"
                        type="button"
                        onClick={() => changeGame(game.gameId, GameMode.Fun)}
                      >
                        {t(T.DEMO)}
                      </button>
                    )}
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  );
});
